import React, { Component } from "react";
import { BuildingList } from "./BuildingList";
import TextField from "@material-ui/core/TextField";
import { Building } from "../Building";
import { Button, Checkbox, FormLabel } from "@material-ui/core";
import { BuildingDialog } from "../BuildingDialog";

export class BuildingsPortal extends Component {
	constructor(props) {
		super(props);
		this.selectBuilding = this.selectBuilding.bind(this);
		this.openDialog = this.openDialog.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
	}
	state = {
		BuildingNameFilter: "",
		CurrentBuilding: null,
		DialogBuilding: null,
		DialogOpen: false,
		UpdateDate: new Date().getTime(),
		IncludeInactive: false,
	};

	selectBuilding(bldg) {
		this.setState({ CurrentBuilding: bldg.buildings_id });
	}

	openDialog(bldg) {
		this.setState({ DialogOpen: true, DialogBuilding: bldg });
	}

	closeDialog() {
		this.setState({ UpdateDate: new Date().getTime(), DialogOpen: false });
	}

	render() {
		return (
			<div style={{ display: "flex", flex: "1 0 100%", flexDirection: "row" }}>
				<BuildingDialog BuildingsID={this.state.DialogBuilding} OnClose={this.closeDialog} visible={this.state.DialogOpen}></BuildingDialog>
				<div style={{ display: "flex", flex: "1 0 200px", flexDirection: "column" }}>
					<div style={{ maxHeight: "115px", padding: "8px", backgroundColor: "white" }}>
						<TextField variant="outlined" label="Search for Building" fullWidth={true} size={"small"} onChange={(event) => this.setState({ BuildingNameFilter: event.target.value })} />
						<Button onClick={() => this.openDialog(null)} variant="contained" size="small" style={{ marginTop: "4px", width: "100%" }} color="primary">
							New Building
						</Button>
						<Checkbox size="small" checked={this.state.IncludeInactive} onClick={(event) => this.setState({ IncludeInactive: event.target.checked })}></Checkbox> <FormLabel>Include inactive?</FormLabel>
					</div>
					{this.state.IncludeInactive ? <BuildingList key="inactive" Condensed={true} Filter={this.state.BuildingNameFilter} Inactive={true} updatedDate={this.state.UpdateDate} onSelectRow={this.selectBuilding}></BuildingList> : <BuildingList key="active" Condensed={true} Filter={this.state.BuildingNameFilter} Inactive={false} updatedDate={this.state.UpdateDate} onSelectRow={this.selectBuilding}></BuildingList>}
				</div>
				<div style={{ display: "flex", flex: "1 1 100%", flexDirection: "column", padding: "4px" }}>
					<Building building={this.state.CurrentBuilding}></Building>
				</div>
			</div>
		);
	}
}
